import {
  Flex,
  VStack,
  Button,
  useDisclosure,
  Icon,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useEditState from '../../../../../../common/src/hooks/useEditState';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import { Claim } from '../../../../types/CompanyScanTypes';
import ClaimsTable from './ClaimsTable';
import NewClaimModal from './NewClaimModal';

interface Props {
  question: FlowsQuestion;
}

const ClaimsInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const { t } = useTranslation();
  const { isOpen, onClose, onOpen } = useDisclosure();

  const { toBeEdited, setToBeEdited, editIndex, setEditIndex } =
    useEditState<Claim>();

  const {
    field: { value, onBlur },
    // error,
  } = useFlowInputComponent({ question, defaultValue: [] });

  const claims = (value as Claim[] | undefined) || [];

  const addClaim = (claim: Claim) => {
    onBlur({ name: question.id, value: [...claims, claim] });
  };

  const editClaim = (claim: Claim, index: number) => {
    if (index > -1) {
      const newClaims = [...claims];
      newClaims[index] = claim;
      onBlur({ name: question.id, value: newClaims });
    }
  };

  const handleOnRemove = (index: number) => {
    onBlur({
      name: question.id,
      value: claims.filter((_, _index) => _index !== index),
    });
  };

  const handleOnEdit = (claim: Claim, index: number) => {
    setToBeEdited(claim);
    setEditIndex(index);
    onOpen();
  };

  const handleOnClose = () => {
    setToBeEdited(undefined);
    setEditIndex(undefined);
    onClose();
  };

  return (
    <VStack spacing="4" align="stretch">
      {isOpen && (
        <NewClaimModal
          claim={toBeEdited}
          isOpen={isOpen}
          onClose={handleOnClose}
          addClaim={addClaim}
          editClaim={(claim) => editClaim(claim, editIndex || 0)}
        />
      )}
      <ClaimsTable
        claims={claims}
        onEdit={handleOnEdit}
        onRemove={handleOnRemove}
      />
      <Flex justify="flex-end">
        <Button
          onClick={onOpen}
          leftIcon={<Icon name="GeneralActionsAdd" />}
          isDisabled={question.rules.is_disabled}
        >
          {t('FLOWS_COMPANY-SCAN_CLAIMS_ADD-CLAIM')}
        </Button>
      </Flex>
    </VStack>
  );
};

export default ClaimsInputComponent;
